import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Portal } from '../../components';
import { Div } from '../../layouts';

const StyledDiscountContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  color: white;
  font-size: 14px;
  height: auto;
  background-color: ${(props) => props.transparent && 'rgba(192, 57, 69, 0.8)'};
  backdrop-filter:  ${(props) => props.transparent && 'blur(10px)'};
  span {
    margin-right:4px;;
  }
`;

const StyledIcon = styled.div`
  display: flex;
  padding-right: 16px;
  justify-content: flex-end;
`;

const StyledDiv = styled.div`
  display: flex;
  flex: 90%;
  justify-content: center;
`;

export default () => {
    const [show, setShow] = useState(true);
    const { t } = useTranslation();

    return (
        <Portal id="#discount-message-prime-hotel">
            {show && (
                <StyledDiscountContainer transparent>
                    <StyledIcon>
                        <Div
                            onClick={() => setShow(false)}
                            className="odf-icon odf-icon-cross-light"
                        />
                    </StyledIcon>
                    <StyledDiv dangerouslySetInnerHTML={{ __html: t('prime.home.hotels.discount.banner') }} />
                </StyledDiscountContainer>
            )}
        </Portal>
    );
};

